import { usePostMessageToParent } from "./usePostMessageToParent";
import { useQuoteId } from "./useQuoteId";
import { useSubmitFaceScanData } from "./useSubmitFaceScanData";
import { useTakeScreenshot } from "./useTakeScreenshot";
import useCameras from "./useCameras";
import useDisableZoom from "./useDisableZoom";
import useError from "./useError";
import useGetLatestContract from "./useGetLatestContract";
import useMonitor from "./useMonitor";
import useTimer from "./useTimer";
import useWarning from "./useWarning";

export {
  useCameras,
  useDisableZoom,
  useError,
  useGetLatestContract,
  useMonitor,
  usePostMessageToParent,
  useQuoteId,
  useSubmitFaceScanData,
  useTakeScreenshot,
  useTimer,
  useWarning,
};
